// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1cy6z","question":"Question_question__1x_Ln","description":"Question_description__zkqTn"};